import { render, staticRenderFns } from "./OTicketSummary.vue?vue&type=template&id=fce40976&"
import script from "./OTicketSummary.vue?vue&type=script&lang=js&"
export * from "./OTicketSummary.vue?vue&type=script&lang=js&"
import style0 from "./OTicketSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports